module.exports = "/images/menu-time-clock.svg?23f7ac84549ec0c76351bf1846a0fafc";